// About page storyline. Sourced from the original https://paydeck.in/page/about-us
// (founding story, beliefs, how it works, people and media coverage), lightly edited for clarity.
// Press logos are downloaded from each publication (or the Internet Archive where the site has closed) into public/images/press.

export const benefits = [
	{
		title: "Rewards on every payment",
		body: "Many credit cards offer up to 2% back as reward points or cashback. Paying through Paydeck lets those rewards work on payments that usually happen in cash or by bank transfer.",
		icon: "Gift"
	},
	{
		title: "A 45 to 50 day breathing space",
		body: "Your card's interest free period gives you time before the money leaves your account. Short term loans in India typically cost 18% to 28% a year by comparison.",
		icon: "CalendarClock"
	},
	{
		title: "Business payments, accounted for",
		body: "Paying for business use? The platform fee can be recorded as a business expense. Your accountant can tell you how it applies to you.",
		icon: "BriefcaseBusiness"
	}
];

export const founders = [
	{
		name: "Saurabh Suman",
		photo: "/images/team/saurabh-suman.jpg",
		role: "Founder and Director",
		body: "Saurabh founded Paydeck after finding there was no way to pay his own rent and housing maintenance by card. He leads the company as one of its directors.",
		href: "https://creditstalk.com/about/"
	},
	{
		name: "Shiv Gaurav Bhargava",
		photo: "/images/team/shiv-gaurav-bhargava.jpg",
		role: "Founding member and Advisor",
		body: "Shiv was a founding member of Paydeck with Saurabh. Today he serves as Chief Strategy Officer at one of India's leading ecommerce companies and advises Paydeck on strategy and business development.",
		href: "https://www.linkedin.com/in/shiv-gaurav-bhargava-7209425/"
	}
];

export const team = [
	{
		name: "Binita Roy",
		photo: "/images/team/binita-roy.jpg",
		role: "Head of Risk and Compliance",
		body: "Binita keeps every payment on the right side of the rules. She is one of the directors of the company."
	},
	{
		name: "Tanmoy Khanra",
		photo: "/images/team/tanmoy-khanra.jpg",
		role: "Head of Product & Security",
		body: "Tanmoy shapes Paydeck Experience & Security. He is passionate about outer and inner space."
	},
	{
		name: "Mimi Paul",
		photo: "/images/team/mimi-paul.jpg",
		role: "Head of Technology and Design",
		body: "Mimi leads engineering, design and the technology innovations that keep Paydeck running."
	}
];

export const press = [
	{
		outlet: "YourStory",
		logo: "/images/press/yourstory.png",
		headline:
			"After losing his business of 14 years, this entrepreneur has bounced back to take on the fintech market.",
		href: "https://yourstory.com/2016/10/paydeck/"
	},
	{
		outlet: "Inc42",
		logo: "/images/press/inc42.png",
		headline:
			"A first of its kind service that lets users pay with debit and credit cards, even where the recipient does not accept cards.",
		href: "https://inc42.com/buzz/indian-startup-hubs-kolkata/"
	},
	{
		outlet: "The Telegraph",
		logo: "/images/press/telegraph.png",
		headline: "Paydeck, a financial technology start up.",
		href: "https://www.telegraphindia.com/business/prop-for-start-ups/cid/1459898"
	},
	{
		outlet: "iamwire",
		logo: "/images/press/iamwire-mark.png",
		logoMark: true,
		headline:
			"A platform that lets users pay by credit card even at places where there is no POS machine.",
		href: "http://www.iamwire.com/2016/12/early-stage-indian-fintech-startups/139331"
	},
	{
		outlet: "IndianCEO",
		logo: "/images/press/indianceo.png",
		logoDark: true,
		headline:
			"Moving money in a quick, convenient and secure way, for any goods or services, regardless of card acceptance.",
		href: "https://indianceo.in/startup/paydeck-payment-anytime-anywhere/"
	},
	{
		outlet: "BW Disrupt",
		logo: "/images/press/bw.png",
		headline:
			"Paydeck's next step is to launch its app in the first quarter of 2017.",
		href: "http://bwdisrupt.businessworld.in/article/-Paydeck-Next-Step-is-to-Launch-Its-App-in-the-First-Quarter-of-2017-/27-12-2016-110330/"
	},
	{
		outlet: "TechStory",
		logo: "/images/press/techstory.png",
		headline:
			"Paydeck, your solution to credit card problems, as India turns to plastic and mobile money.",
		href: "https://techstory.in/paydeck/"
	}
];
